import { Link } from 'react-router-dom'
import globalStyle from '../../styles/common.module.css'
import style from './pages.module.css'
import { PagesQuery } from '../../util/types'
import React from 'react'

function Instructions({data}: {data: PagesQuery["pages"][number] | undefined}) {
  if (!data) {
    return null;
  }

  return (
    <div className={[globalStyle.grid10, globalStyle.gridCenter, globalStyle.gridFlex, style.instructions].join(' ')}>
      <div className={globalStyle.grid6}>
        <h1 className={[globalStyle.subtitle, globalStyle.underline, style.instructionsHeader].join(' ')}> {data.title.toLowerCase()} </h1>
        {
          data.blurb && 
        <div className={[globalStyle.bodyLG, style.body].join(' ')} dangerouslySetInnerHTML={{ __html: data.blurb.html }} />
        }
        <Link
          className={[globalStyle.button, globalStyle.buttonSM, globalStyle.right].join(' ')}
          to="/collections"
        >
          Begin!
        </Link>
      </div>
      <div className={[globalStyle.grid3, style.instructionScribble].join(' ')}>
        <img src='assets/icons/instructions.svg' alt='decorative scribble' />
      </div>
    </div>
  )
}

export { Instructions }